function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBacteria = function SvgBacteria(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m247.171875 97.101562c-4.875 0-8.828125-3.949218-8.828125-8.824218v-35.3125c0-4.875 3.953125-8.828125 8.828125-8.828125s8.828125 3.953125 8.828125 8.828125v35.3125c0 4.875-3.953125 8.824218-8.828125 8.824218zm0 0",
    fill: "#b0d76a",
    "data-original": "#65ddb9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m128.574219 146.230469c-2.339844-.003907-4.585938-.933594-6.242188-2.589844l-31.214843-31.210937c-3.34375-3.464844-3.296876-8.972657.109374-12.375 3.40625-3.40625 8.910157-3.453126 12.375-.109376l31.214844 31.214844c2.523438 2.523438 3.277344 6.320313 1.910156 9.617188-1.363281 3.300781-4.582031 5.449218-8.152343 5.453125zm0 0",
    fill: "#b0d76a",
    "data-original": "#65ddb9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m79.449219 264.828125h-35.3125c-4.875 0-8.828125-3.953125-8.828125-8.828125s3.953125-8.828125 8.828125-8.828125h35.3125c4.875 0 8.828125 3.953125 8.828125 8.828125s-3.953125 8.828125-8.828125 8.828125zm0 0",
    fill: "#b0d76a",
    "data-original": "#65ddb9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m97.359375 414.640625c-3.570313 0-6.789063-2.152344-8.152344-5.449219-1.367187-3.296875-.613281-7.09375 1.910157-9.621094l31.214843-31.210937c3.464844-3.347656 8.96875-3.300781 12.375.105469s3.453125 8.910156.109375 12.375l-31.214844 31.214844c-1.65625 1.65625-3.902343 2.585937-6.242187 2.585937zm0 0",
    fill: "#b0d76a",
    "data-original": "#65ddb9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m247.171875 467.863281c-4.875 0-8.828125-3.953125-8.828125-8.828125v-35.3125c0-4.875 3.953125-8.824218 8.828125-8.824218s8.828125 3.949218 8.828125 8.824218v35.3125c0 4.875-3.953125 8.828125-8.828125 8.828125zm0 0",
    fill: "#b0d76a",
    "data-original": "#65ddb9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m396.984375 414.640625c-2.339844 0-4.585937-.929687-6.238281-2.585937l-31.214844-31.214844c-3.347656-3.464844-3.300781-8.96875.105469-12.375s8.910156-3.453125 12.375-.105469l31.214843 31.210937c2.523438 2.527344 3.277344 6.324219 1.914063 9.621094-1.367187 3.296875-4.585937 5.449219-8.15625 5.449219zm0 0",
    fill: "#b0d76a",
    "data-original": "#65ddb9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m459.035156 264.828125h-44.136718c-4.878907 0-8.828126-3.953125-8.828126-8.828125s3.949219-8.828125 8.828126-8.828125h44.136718c4.875 0 8.828125 3.953125 8.828125 8.828125s-3.953125 8.828125-8.828125 8.828125zm0 0",
    fill: "#b0d76a",
    "data-original": "#65ddb9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m365.769531 146.230469c-3.566406-.003907-6.785156-2.152344-8.152343-5.453125-1.367188-3.296875-.609376-7.09375 1.914062-9.617188l31.214844-31.214844c2.214844-2.292968 5.496094-3.214843 8.582031-2.40625 3.085937.808594 5.496094 3.21875 6.304687 6.304688.808594 3.085938-.113281 6.367188-2.40625 8.585938l-31.214843 31.210937c-1.65625 1.65625-3.898438 2.585937-6.242188 2.589844zm0 0",
    fill: "#b0d76a",
    "data-original": "#65ddb9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m414.898438 256c0 92.632812-75.09375 167.722656-167.726563 167.722656s-167.722656-75.089844-167.722656-167.722656 75.089843-167.722656 167.722656-167.722656 167.726563 75.089844 167.726563 167.722656zm0 0",
    fill: "#6dc37b",
    "data-original": "#46b29d",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m247.171875 397.242188c-4.875 0-8.828125-3.953126-8.828125-8.828126s3.953125-8.828124 8.828125-8.828124c68.226563-.074219 123.515625-55.363282 123.585937-123.585938 0-4.875 3.953126-8.828125 8.828126-8.828125s8.828124 3.953125 8.828124 8.828125c-.09375 77.96875-63.273437 141.148438-141.242187 141.242188zm0 0",
    fill: "#b0d76a",
    "data-original": "#65ddb9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#14a085"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m317.792969 194.207031c0 19.5-15.808594 35.308594-35.308594 35.308594-19.503906 0-35.3125-15.808594-35.3125-35.308594s15.808594-35.308593 35.3125-35.308593c19.5 0 35.308594 15.808593 35.308594 35.308593zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.207031 220.691406c0 14.625-11.855469 26.480469-26.484375 26.480469-14.625 0-26.480468-11.855469-26.480468-26.480469 0-14.628906 11.855468-26.484375 26.480468-26.484375 14.628906 0 26.484375 11.855469 26.484375 26.484375zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.65625 300.136719c0 14.628906-11.859375 26.484375-26.484375 26.484375s-26.480469-11.855469-26.480469-26.484375c0-14.625 11.855469-26.480469 26.480469-26.480469s26.484375 11.855469 26.484375 26.480469zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.070312 308.964844c-1.15625-.011719-2.292968-.253906-3.355468-.707032-1.070313-.445312-2.054688-1.074218-2.914063-1.851562-.796875-.84375-1.425781-1.832031-1.851562-2.914062-.453125-1.0625-.695313-2.199219-.707031-3.355469.035156-2.335938.949218-4.574219 2.558593-6.265625.859375-.78125 1.84375-1.40625 2.914063-1.855469 3.292968-1.332031 7.058594-.605469 9.621094 1.855469 1.613281 1.691406 2.527343 3.929687 2.5625 6.265625-.015626 1.15625-.253907 2.292969-.707032 3.355469-.425781 1.082031-1.058594 2.070312-1.855468 2.914062-1.691407 1.609375-3.929688 2.523438-6.265626 2.558594zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.207031 361.929688c-1.152343-.011719-2.292969-.253907-3.355469-.703126-1.070312-.449218-2.054687-1.078124-2.914062-1.855468-.796875-.84375-1.425781-1.832032-1.851562-2.914063-.453126-1.058593-.691407-2.199219-.707032-3.355469.035156-2.335937.949219-4.574218 2.558594-6.265624.859375-.777344 1.84375-1.40625 2.914062-1.855469 3.292969-1.332031 7.0625-.605469 9.621094 1.855469 1.613282 1.691406 2.527344 3.929687 2.5625 6.265624-.015625 1.15625-.253906 2.296876-.707031 3.355469-.425781 1.082031-1.054687 2.070313-1.855469 2.914063-1.691406 1.613281-3.929687 2.527344-6.265625 2.558594zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.65625 26.484375c0 14.625-11.859375 26.480469-26.484375 26.480469s-26.480469-11.855469-26.480469-26.480469c0-14.628906 11.855469-26.484375 26.480469-26.484375s26.484375 11.855469 26.484375 26.484375zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.707031 81.222656c0 19.5-15.8125 35.308594-35.3125 35.308594s-35.308593-15.808594-35.308593-35.308594 15.808593-35.308594 35.308593-35.308594 35.3125 15.808594 35.3125 35.308594zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.136719 256c0 12.1875-9.878907 22.070312-22.066407 22.070312-12.191406 0-22.070312-9.882812-22.070312-22.070312s9.878906-22.070312 22.070312-22.070312c12.1875 0 22.066407 9.882812 22.066407 22.070312zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.707031 430.777344c0 19.5-15.8125 35.308594-35.3125 35.308594s-35.308593-15.808594-35.308593-35.308594 15.808593-35.308594 35.308593-35.308594 35.3125 15.808594 35.3125 35.308594zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273.65625 485.515625c0 14.628906-11.859375 26.484375-26.484375 26.484375s-26.480469-11.855469-26.480469-26.484375c0-14.625 11.855469-26.480469 26.480469-26.480469s26.484375 11.855469 26.484375 26.480469zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.261719 430.777344c0 19.5-15.8125 35.308594-35.3125 35.308594s-35.308594-15.808594-35.308594-35.308594 15.808594-35.308594 35.308594-35.308594 35.3125 15.808594 35.3125 35.308594zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 14.625-11.855469 26.484375-26.484375 26.484375-14.625 0-26.480469-11.859375-26.480469-26.484375s11.855469-26.484375 26.480469-26.484375c14.628906 0 26.484375 11.859375 26.484375 26.484375zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.261719 81.222656c0 19.5-15.8125 35.308594-35.3125 35.308594s-35.308594-15.808594-35.308594-35.308594 15.808594-35.308594 35.308594-35.308594 35.3125 15.808594 35.3125 35.308594zm0 0",
    fill: "#327850",
    "data-original": "#14a085",
    style: {},
    className: ""
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBacteria, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bacteria.82f6a04f.svg";
export { ForwardRef as ReactComponent };